import {identifyScreen} from './utility';
export let skreen = identifyScreen(200);
// export let baseURL = (skreen==="desktolp") ? 'http://localhost:3000' : 'http://192.168.1.4:3000';
export let baseURL = 'https://ishopsaz.com/instagram';
// export let baseURL = 'http://localhost:3000';